class SubcaseCommentSectionController {
  /* @ngInject */
  constructor($http, $stateParams, $state, Session, moment, urls) {
    this.$http = $http;
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.Session = Session;
    this.moment = moment;
    this.urls = urls;
  }

  $onInit() {
    this.ui = { scrollToBottom: false };
    this.user = this.Session.read('userinfo');
  }

  submit(form) {
    if (form.$invalid || this.submitting) return;

    const comment = this.comment;
    this.comment = '';

    this.submitting = true;
    this.$http.post(`/subCase/${this.subCase.id}/comment`, {
      comment,
    })
      .then(() => {
        this.submitting = false;
        this.ui.scrollToBottom = false;

        this.subCase.comments.push({
          sub_case_id: this.subCase.id,
          comment,
          Creator: { name: this.user.name },
        });
      })
      .catch(() => (this.submitting = false));
  }

  getStateAttachmentLink(comment) {
    return `${this.urls.API_SERVER}/api/subCase/state/${
      comment.id}/attachment?access_token=${this.Session.accessToken}`;
  }
}

export default SubcaseCommentSectionController;



// WEBPACK FOOTER //
// ./client/components/subcase-comment-section/subcase-comment-section.controller.js